import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/esm/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/esm/plugin/isSameOrBefore";
import { useSchoolStore } from "@/stores/school";
import { useAuthenticationStore } from "@/stores/authentication";
import { useConferenceStore } from "@/stores/parent/conference";
import utc from "dayjs/esm/plugin/utc";

dayjs.extend(utc);

// import * as isAfter from 'dayjs/plugin/isAfter';
// import * as isBefore from 'dayjs/plugin/isBefore';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
// dayjs.extend(isBefore);
// dayjs.extend(isAfter)

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useTeacherStore = defineStore("parent/teacher", {
  state: () => {
    return {
      selected: [],
      // conferenceDays: [],
      // selectedConferenceDay: null,
      loading: false,
      loading_teachers: false,
      loading_teams: false,
      error: null,
      teachers: [],
      teams: [],
      show_drawer: false,
      sort_key: "Name",
      sort_asc: true
    };
  },
  getters: {
    count() {
      if (Object.keys(this.selected)) {
        return Object.keys(this.selected).length;
      } else {
        return 0;
      }
    },
    getSelectedIndexById: (state) => {
      return (teacher_uid) =>
        state.selected.findIndex((teacher) => teacher.value.uid === teacher_uid);
    },
    getIndexById: (state) => {
      return (teacher_uid) => state.teachers.findIndex((teacher) => teacher.uid === teacher_uid);
    },
    getTeamIndexById: (state) => {
      return (team_uid) => state.teams.findIndex((team) => team.uid === team_uid);
    },
    getById: (state) => {
      return (teacher_uid) =>
        Object.entries(state.teachers).find((teacher) => teacher.uid == teacher_uid);
    }
  },
  actions: {
    sort(a, b) {
      let a_key, b_key;
      if (this.sort_key == "Name") {
        if (a.teacher_id !== undefined) {
          a_key = a.teacher_lname;
        } else {
          a_key = a.name;
        }
        if (b.teacher_id !== undefined) {
          b_key = b.teacher_lname;
        } else {
          b_key = b.name;
        }
      } else if (this.sort_key == "Description") {
        a_key = a.description;
        b_key = b.description;
      }
      if (a_key < b_key) {
        if (this.sort_asc) return -1;
        else return 1;
      } else if (a_key > b_key) {
        if (this.sort_asc) return 1;
        else return -1;
      } else {
        return 0;
      }
    },
    async fetchTeacherConflict(conferenceDay, teacher) {
      const conflicts = await FetchService.fetchData(
        "/schedule/teacher/" + teacher.uid + "/conference_day/" + conferenceDay.conference_days_id,
        "get"
      );
      // const t1 = Object.entries(this.teachers).find((t) => t.uid == teacher.uid);
      const index = this.getSelectedIndexById(teacher.uid);
      if (index >= 0) {
        this.selected[index].value.conflicts = conflicts;
        return conflicts;
      } else {
        return [];
      }
    },
    async fetchTeamConflict(conferenceDay, team) {
      const conflicts = await FetchService.fetchData(
        "/schedule/team/" + team.uid + "/conference_day/" + conferenceDay.conference_days_id,
        "get"
      );
      // const t1 = Object.entries(this.teachers).find((t) => t.uid == teacher.uid);
      const index = this.getSelectedIndexById(team.uid);
      if (index >= 0) {
        this.selected[index].value.conflicts = conflicts;
        return conflicts;
      } else {
        return [];
      }
    },
    async fetchAllTeachers(conferenceId) {
      this.loading = true;
      this.loading_teachers = true;
      this.loading_teams = true;
      FetchService.fetchData("/conference/" + conferenceId + "/teachers?all=true", "get").then(
        (teachers) => {
          if (Array.isArray(teachers)) {
            this.teachers = teachers;
          }
          this.loading_teachers = false;
          if (!this.loading_teams) {
            this.loading = false;
          }
        }
      );
      FetchService.fetchData("/conference/" + conferenceId + "/teams?all=true", "get").then(
        (teams) => {
          if (Array.isArray(teams)) {
            this.teams = teams;
          }
          this.loading_teams = false;
          if (!this.loading_teachers) {
            this.loading = false;
          }
        }
      );
    },
    async fetchTeachers(conferenceId, all = false) {
      this.loading = true;
      this.loading_teachers = true;
      this.loading_teams = true;
      FetchService.fetchData("/conference/" + conferenceId + "/teachers?all=" + all, "get").then(
        (teachers) => {
          this.teachers = teachers;
          this.loading_teachers = false;
          if (!this.loading_teams) {
            this.loading = false;
          }
        }
      );
      FetchService.fetchData("/conference/" + conferenceId + "/teams?all=" + all, "get").then(
        (teams) => {
          this.teams = teams;
          this.loading_teams = false;
          if (!this.loading_teachers) {
            this.loading = false;
          }
        }
      );
    },
    isConflict(a1, a2, b1, b2) {
      /*
                1)  a1 < b2 & a2 > b2 = Meeting A starts during Meeting B and finishes after Meeting B
                2)  a1 < b1 & a2 > b1 = Meeting A starts before Meeting B and finishes during Meeting B
                3)  a1 < b2 & a2 < b1 = Meeting A starts and finishes during Meeting B
                4)  a1 <= b1 & a2 >= b2 = Meeting A starts before or at the same time as Meeting B and finishes at the same time or after Meeting B
            */
      if (
        (a1.isBefore(b2) && a2.isAfter(b2)) ||
        (a1.isBefore(b1) && a2.isAfter(b1)) ||
        (a1.isBefore(b2) && a2.isAfter(b1)) ||
        (a1.isSameOrBefore(b1) && a2.isSameOrAfter(b2))
      ) {
        return true;
      } else {
        return false;
      }
    },
    generateConflicts(teacher_team, day) {
      const startTime = day.start;
      const endTime = day.end;
      var x = dayjs(startTime);
      var y = dayjs(endTime);
      var diff = y.diff(x, "minute", true) / day.time_interval;
      var conflicts = [];
      var timeslots = [];
      for (var i = 0; i < diff; i++) {
        const conflict = {
          conference_id: day.conference_id,
          conference_days_id: day.conference_days_id,
          teacher_uid: teacher_team.uid,
          timeslot: "2022-07-05 17:00:00",
          time_interval: day.time_interval
        };
        var timeslot = {
          timeslot: x,
          start_time: x,
          end_time: x.add(day.time_interval, "minute"),
          duration: day.time_interval,
          disabled: true,
          type: "unavailable"
        };
        conflicts.push(conflict);
        timeslots.push(timeslot);
        x = x.add(day.time_interval, "minute");
      }
      teacher_team.conflicts = conflicts;
      teacher_team.timeslots = timeslots;
    },
    isDoubleBookingEnabled(school, conference) {
      const schoolDoubleBookings = school?.double_bookings;
      const schoolEnabled =
        schoolDoubleBookings === true ||
        schoolDoubleBookings === "yes" ||
        schoolDoubleBookings === 1 ||
        schoolDoubleBookings === "1";
      return schoolEnabled || conference?.selected?.allow_double_booking === true;
    },
    getBookableStudentCount(teacher_team, school, parentStudents) {
      const students = parentStudents ?? [];
      if (school?.integration == null || school?.integration == "none") {
        return students.length;
      }
      if (teacher_team.students?.length > 0) {
        return teacher_team.students.length;
      }
      return students.length;
    },
    clearDisabledTimeslots(teacher_team) {
      if (teacher_team.timeslots === undefined) {
        return false;
      }
      teacher_team.timeslots.forEach((timeslot) => {
        if (timeslot.type != "unavailable" && timeslot.type != "reserved") {
          timeslot.disabled = false;
          timeslot.type = "available";
          timeslot.checked = false;
          timeslot.id = null;
        }
      });
    },
    disableTimeslots(teacher_team, day, meeting) {
      if (teacher_team.timeslots === undefined) {
        return false;
      }
      const schoolStore = useSchoolStore();
      const authenticationStore = useAuthenticationStore();
      const travelTime = day.travel_time ? day.travel_time : 0;
      var uid = meeting.teacher_uid ?? meeting.team_uid;
      var reserved_meetings = teacher_team.timeslots.filter(
        (t) => t.type == "reserved" && t.id != meeting.pta_id
      );
      var reserved_count = reserved_meetings ? reserved_meetings.length + 1 : 1;
      var students = this.getBookableStudentCount(
        teacher_team,
        schoolStore.school,
        authenticationStore.me?.students
      );
      teacher_team.timeslots.forEach((timeslot) => {
        if (timeslot.type != "unavailable" && timeslot.type != "reserved") {
          //   agendaStore.conference_agenda[conferenceStore.selected.conference_id].forEach((meeting) => {
          var meetingTimeStart = dayjs.utc(meeting.start ?? meeting.timeslot);
          var meetingTimeEnd = dayjs.utc(meeting.end).add(travelTime, "minute");
          //Is this teacher the same as the meeting teacher?  If it is not, then check for conflicts.  If it is, then disable the other meeting times with this teacher
          if (teacher_team.uid == uid) {
            // Disable remaining slots once every bookable student has an appointment.
            // double_bookings only allows additional bookings while students remain unbooked.
            if (
              !timeslot.start_time.isSame(meetingTimeStart) &&
              reserved_count >= students &&
              timeslot.type != "reserved"
            ) {
              // if (!timeslot.start_time.isSame(meetingTimeStart) && timeslot.type !== 'reserved'){
              timeslot.type = "disabled";
              timeslot.disabled = true;
              timeslot.checked = false;
            }
          } else {
            // Check for time conflicts with overlap etc.
            if (
              timeslot.type != "reserved" &&
              this.isConflict(
                meetingTimeStart,
                meetingTimeEnd,
                timeslot.start_time,
                timeslot.end_time
              )
            ) {
              timeslot.type = "disabled";
              timeslot.disabled = true;
              timeslot.checked = false;
            }
          }
        }
      });
    },

    createTimeslots(day, timeInterval, smallestTimeInterval) {
      const startTime = day.start;
      const endTime = day.end;
      // const time_interval = 15;
      var x = dayjs.utc(startTime);
      var y = dayjs.utc(endTime);
      var diff = y.diff(x, "minute", true) / timeInterval;
      var timeslots = [];
      var heightPx = 40;
      if (smallestTimeInterval != null) {
        var maxTimeslots = y.diff(x, "minute", true) / smallestTimeInterval;
        heightPx = (40 * maxTimeslots) / diff + (smallestTimeInterval - 15);
      }
      for (var i = 0; i < diff; i++) {
        timeslots.push({
          time: x.format("h:mm A"),
          start_time: x.toString(),
          end_time: x.add(timeInterval, "minute").toString(),
          duration: smallestTimeInterval,
          height: heightPx
        });
        x = x.add(timeInterval, "minute");
      }
      return timeslots;
    },

    createTeacherTimeslots(teacher_team, day, time_interval, agenda) {
      const startTime = day.start;
      const endTime = day.end;
      const passingTime = day.passing_time ? day.passing_time : 0;
      var x = dayjs.utc(startTime);
      var y = dayjs.utc(endTime);
      // diff = the number of time slots to create.  this is based breaking up the day into timeslots using time interval plus passing time to create the correct number.
      var diff = y.diff(x, "minute", true) / (time_interval + passingTime);
      var timeslots = [];
      // We don't include passing time into the timeslot itself, because the timeslots are based on the time interval and the passingTime is not actually part of the meeting.
      for (var i = 0; i < diff; i++) {
        var timeslot = {
          timeslot: x,
          start_time: x,
          end_time: x.add(time_interval, "minute"),
          duration: time_interval,
          disabled: false,
          type: "available"
        };
        // Merge in the teacher conflict times
        if (teacher_team.conflicts !== undefined && teacher_team.conflicts != null) {
          teacher_team.conflicts?.forEach?.((conflict) => {
            var uid = conflict.teacher_uid ? conflict.teacher_uid : conflict.team_uid;
            if (dayjs.utc(conflict.timeslot).isSame(x) && teacher_team.uid == uid) {
              timeslot.disabled = true;
              timeslot.type = "unavailable";
            }
          });
        }
        // Merge in the existing appointments from the agenda
        var existing_meeting = agenda.find(
          (meeting) =>
            meeting.conference_days_id == day.conference_days_id &&
            (meeting.teacher_uid == teacher_team.uid || meeting.team_uid == teacher_team.uid) &&
            dayjs.utc(meeting.timeslot).isSame(x)
        );
        if (existing_meeting) {
          timeslot.disabled = false;
          timeslot.type = "reserved";
          timeslot.checked = "checked";
          timeslot.id = existing_meeting.pta_id;
        }

        timeslots.push(timeslot);
        x = x.add(time_interval + passingTime, "minute");
      }
      teacher_team.timeslots = timeslots;
    }
  }
});
